module.exports = __webpack_public_path__ + "static/media/Joshua Cohen-Dumani.4574b742.svg";